export default __webpack_public_path__ + "static/media/06_warehouse.aa987983.svg";